import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ClienteI {
  id?: string;
  name_lastname: string;
  checkIn: string;
  checkOut: string;
  persons: number;
  email: string;
  telefono: string;
  comentario: string;
  patente?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactsService {

  contactos$: Observable<ClienteI[]>;
  private _clienteCollection: AngularFirestoreCollection<ClienteI>;

  constructor(private afs: AngularFirestore) {
    this._clienteCollection = afs.collection<ClienteI>('clients');
    this.contactos$ = this._getContacts();
  }

  private _getContacts() {
    return this._clienteCollection.snapshotChanges().pipe(map(
      actions => {
        return actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        });
      }
    ));
  }

  public async saveContact(cliente: ClienteI) {
    return this._clienteCollection.add(cliente);
  }

  deleteContact(clienteId: string) {
    this._clienteCollection.doc(clienteId).delete();
  }
}
